export default __webpack_public_path__ + "static/media/back.6942233f.svg";